import * as React from "react";
import { SVGProps } from "react";
const NewMemberIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="46"
    viewBox="0 0 47 46"
    {...props}
  >
    <g stroke="currentColor" data-name="Group 2">
      <path
        fill="none"
        strokeWidth={3}
        d="M19.797 22.03c-.741-1.18-2.131-2.783-2.131-4.166a2.231 2.231 0 0 1 1.5-2.026 59.341 59.341 0 0 1-.116-3.531c0-.7.013-1.4.039-2.086a7.157 7.157 0 0 1 .235-1.289 7.427 7.427 0 0 1 3.313-4.212 9.4 9.4 0 0 1 1.8-.86c1.137-.416.587-2.333 1.837-2.36 2.919-.076 7.716 2.6 9.588 4.621a7.4 7.4 0 0 1 1.911 4.8l-.119 5.111a1.679 1.679 0 0 1 1.227 1.051c.4 1.613-1.275 3.621-2.053 4.9-.718 1.184-3.46 5.015-3.463 5.042a1.021 1.021 0 0 0 .246.6c.043.06.09.12.157.2.905 2.277 2.531 2.349 3.575 2.9 2.515 1.327 10.39 5.408 8.62 10.692-3.57.133-7.741.063-9.125 0H8.274c0-11.647 10.4-7.947 14.654-13.8.21-.309.306-.476.3-.611 0-.073-3.153-4.535-3.435-4.984Z"
      />
      <path
        fill="#366287"
        strokeWidth={2}
        d="M2.06 29.323a10.784 10.784 0 1 1 .329 11.158C.388 37.195.797 31.737 2.06 29.323Z"
        data-name="male-user-add-icon"
      />
      <g
        fill="currentColor"
        strokeLinecap="round"
        strokeWidth={2}
        data-name="Group 3"
      >
        <path d="M11.624 28.472v12" data-name="Line 1" />
        <path d="M17.624 34.472h-12" data-name="Line 2" />
      </g>
    </g>
  </svg>
);

export default NewMemberIcon;
